import {
  SupplementalFormDefaultValues,
  SupplementalFormProps,
  SupplementalFormRawValues,
  SupplementalFormType
} from "./SupplementalForm";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";

const getInitialValues = (defaultValues: SupplementalFormDefaultValues | undefined): SupplementalFormRawValues => {
  return {
    type: defaultValues?.type?.code,
    displayName: defaultValues?.displayName,
    description: defaultValues?.description,
    reportable: defaultValues?.reportable,
  }
}

export type UseSupplementalFormProps = Pick<SupplementalFormProps, 'defaultValues'> & {}

export function useSupplementalForm(props: UseSupplementalFormProps): SupplementalFormType {
  const {
    defaultValues
  } = props

  const {t} = useTranslation(["common"])

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
    }),
    validate: {
      file: (value) => value ? undefined : t("common.validation.required", "Required"),
    },
  })

  return form
}
